var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LedgerModal',{staticClass:"ledger-address-confirm",attrs:{"title":_vm.create
      ? _vm.$t('ledger.modal.address-confirm.create-guide')
      : _vm.$t('ledger.modal.address-confirm.confirm-guide')}},[_c('LedgerModalNanoS'),_c('AeAddressPanel',{attrs:{"title":_vm.$t('ledger.modal.address-confirm.address'),"address":_vm.address}}),_c('LedgerModalNote',[_vm._v(" "+_vm._s(_vm.create ? _vm.$t('ledger.modal.address-confirm.create-note') : _vm.$t('ledger.modal.address-confirm.confirm-note'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }